export const CATEGORY_GREFFE = 12;
export const CATEGORY_LEGAL_ANNOUCEMENT = 5;
export const CATEGORY_TAXES = 6;
export const CATEGORY_BODACC = 7;
